import {listify, objectify} from "radash";


const submitJson = (url, data, method) =>
    fetch(url, {
        method: method,
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    })


export const post = (url, data) => submitJson(url, data, 'POST')

export const put = (url, data) => submitJson(url, data, 'PUT')

export const getPipelineList = () =>
    fetch(`/api/pipelines`)


export const getPipelineInstance = pid =>
    fetch(`/api/pipelines${pid}`)

export const resetPassword = (password, guid) =>
    put(`/resetPassword`, {password, guid})


export const latestPipelineInstance = (pid, keys) =>
    put(`/api/pipelines${pid}`, {command: 'latest', keys})

export const getPipelineInstanceExists = (ptype, name) =>
    fetch(`/api/pipelineExists/${ptype}/${name}`)

export const getTask = (pid, taskKey) =>
    fetch(`/api/pipelines${pid}?t=${taskKey}`)

export const restartTask = (pid, {taskKey, atStep=null, reset=false}) => {

    const a = {
        t: taskKey,
        s: atStep,
        r: reset
    }

    const args = listify(a, (k, v) => `${k}=${v}`).join("&")

    return fetch(`/api/restart${pid}?${args}`)
}


export const getLsPipelines = state =>
    fetch(`/api/ls/pipelines/${state}`)

export const createNewPipeline = (instanceDirBaseName, name, args) =>
    post(`/api/pipelines/${instanceDirBaseName}/${name}`, {args: args})

export const savePipelineInstanceArgs = (pid, args) =>
    put(`/api/pipelines${pid}`, {command: 'saveArgs', args})

export const startPipelineInstance = pid =>
    put(`/api/pipelines${pid}`, {command: 'start'})

export const preRunPipelineInstance = pid =>
    put(`/api/pipelines${pid}`, {command: 'preRun'})

export const getPipelineFiles = pid =>
    fetch(`/api/pipelineFiles${pid}`)

export const getPipelineTypes = () =>
    fetch(`/api/pipelineTypes`)

export const deletePipelineFiles = (pid, {fileNames}) =>
    put(`/api/pipelineFiles${pid}`, {fileNames})

export const login = (email, password) =>
    post(`/api/login`, {email, password})

export const fetchDoc = (pipelineType, fileName, {format}) => {
    const f = format ? `?format=${format}`: ''
    return fetch(`/api/doc/${pipelineType}/${fileName}${f}`)
}

export const command = (pid, name, args) => {

    const a = listify(args, (k, v) => `${k}=${v}`).join("&")
    return fetch(`/api/command/${name}/${pid}?${a}`)
}
